import React, { Component } from "react";
import { connect } from "react-redux";
import { NavLink } from "react-router-dom";
import { withRouter } from "react-router";
import { isNewUser, refreshOffers, editOffer, phoneRequiredType } from "./../../actions";
import {
	deleteOffer,
	getCancelationReasons,
	getExtractResale,
	postLogDecisionResale,
	getInstallmentsResale,
	postReportProblemResale,
	getCustomerFinancialPending,
	postCreatePaymentUrl
} from "./../../shared/requests-api";
import { getUserToken, formatDateToLocalDate } from "../../shared/utils";
import Loading from "../../../shared/Loading/Loading";
import { OfferStatus } from "../../shared/enums";
import Select from "./../../../shared/Select/Select";
import R from "ramda";
import ItemListOffer from "./template/ItemListOffer";
import { ROUTE_SALE, ROUTE_SALE_MILES } from "../../shared/constants";
import { formatCurrency, intFormat } from "../../../../js/shared/utils";
import { CookieTypes, setCookie } from "../../../../js/shared/cookie";
import SummaryPayment from "./SummaryPayment";
import Button from "./../../../shared/button/button";
import { isMobile } from "./../../../../js/components/searchform/utils/common";
import PaymentGuarantee from "../../../shared/PaymentGuarantee/PaymentGuarantee";
import Callout from "../../../shared/Callout/Callout";
import DeleteOfferModal from "./DeleteOfferModal";
import { logEvent } from "../../shared/firebase";
import {
	EditarNaoElegivel,
	EditarNaoElegivelPagamentoAntecipado,
	EditarPerderBonus
} from "../../services/modals";
import Collapse from "../molecules/Collapse";
import CollapseCard from "../molecules/CollapseCard";
import ResaleForm from "./ResaleForm";
import jwt_decode from "jwt-decode";
import SalesLink from "../molecules/SalesLink";
import Radio from "../../../shared/Radio/Radio";
import {
	Button as ButtonAtomic
} from "@maxmilhas/hangar-components-atomic/public";
import { NewOfferContext } from "../../../js/context/new-offer";
import Checkbox from '../../../shared/Checkbox/Checkbox';
import ModalReportProblem from "./ModalReportProblem";
import Modal from '../../../shared/create-offer/Modal/Modal';

let globalLocale;

const sortOptions = [
	{
		label: "Programa de fidelidade",
		value: "fidelity.name"
	},
	{
		label: "Quantidade de milhas",
		value: "quant"
	},
	{
		label: "Última modificação",
		value: "lastUpdate"
	}
];

const errorsOptions = [
	{
		key: "Invalid username for airline program!",
		value: `Neste momento não é possível utilizar a troca 
		rápida de preço, por gentiliza, siga o fluxo 
		normal de edição e na sua próxima edição já 
		será possível utilizar esse recurso`
	}
];

const resaleCommonContent = {
	title: "Cancelamento por parte do viajante",
	text:
		"O viajante cancelou uma ou mais passagens emitidas com as milhas vendidas por você em nossa plataforma. Como o pagamento já havia sido realizado na sua conta bancária, foi gerado um débito com a Maxmilhas",
	buttonText: "Resolver agora",
	buttonTextReportProblem: "Relatar problema"
};

const financialPendingCommonContent = {
	title: "Cancelamento sem autorização do viajante",
	text:
		"Uma ou mais passagens emitidas com as suas milhas foram canceladas sem a autorização do viajante. Isso pode ter ocorrido por iniciativa sua, ou devido a inconsistência do seu programa de fidelidade. Com isso, foi gerado um débito para você, que pode incluir tanto o valor já pago pelas suas milhas como também as despesas extras para reembolso / reemissão de uma nova passagem",
	buttonText: "Resolver agora",
	buttonTextReportProblem: "Relatar problema"
};

const reportOptions = {
	resale: [
		{
			value: "1",
			label: "As milhas não foram reembolsadas no programa de fidelidade"
		},
		{
			value: "2",
			label: "Eu já efetuei o pagamento/reutilização dessas milhas"
		},
		{
			value: "3",
			label: "As milhas expiraram.",
			smallDescription: "Será necessário acesso a sua conta para comprovação."
		}
	],
	financialPending: [
		{
			value: "4",
			label: "Não reconheço esse débito"
		},
		{
			value: "5",
			label: "Eu já efetuei o pagamento desse débito"
		}
	]
}

const financialPendingModalData = {
	paid: {
		title: 'Pagamento realizado',
		text: 'O pagamento realizado por você foi processado com sucesso.',
		buttonText: 'Ok, entendi'
	},
	error: {
		title: 'Algo deu errado...',
		text: 'Uma falha ocorreu ao tentar redirecionar para o pagamento. Tente novamente mais tarde.',
		buttonText: 'Ok, entendi'
	}
}

class MyOffers extends Component {
	constructor() {
		super();

		this.state = {
			allOffers: [],
			sortOption: { label: "Ordenar por ", value: "lastUpdate" },
			asc: true,
			filterOption: "",
			filterOptionSelected: { label: "Todos", value: "" },
			failedSend: false,
			options: [],
			hasComponentQuickSaleActive: false,
			offer: {},
			resale: {
				hasDebt: false,
				solveDebtLater: false,
				solveDebtNow: false
			},
			financialPending: {
				hasFinancialPending: false,
				solveFinancialPendingLater: false,
			},
			isGeneratingPaymentLink: false,
			selectedFinancialPendingDebts: [],
			showFinancialPendingPaymentStatusModal: false,
			showFinancialPendingPaymentError: false,
			opened: false,
			index: undefined,
			resaleCharge: {},
			financialPendingCharge: {},
			installments: undefined,
			selectedIdMov: null,
			showModalResaleReportProblem: false,
			showModalFinancialPendingReportProblem: false,
			txtAreaReportProblem: "",
			radioReportProblem: null,
			submitting: false
		};

		this.showModalDelete = this.showModalDelete.bind(this);
		this.confirmModalDelete = this.confirmModalDelete.bind(this);
		this.cancelModalDelete = this.cancelModalDelete.bind(this);
		this.setComponentQuickSaleActive = this.setComponentQuickSaleActive.bind(this);
		this.handlePriceChange = this.handlePriceChange.bind(this);
		this.edit = this.edit.bind(this);
		this.confirmEdit = this.confirmEdit.bind(this);
		this.displayDebitDetailsGrid = this.displayDebitDetailsGrid.bind(this);
		this.solveDebtClick = this.solveDebtClick.bind(this);
	}

	static contextType = NewOfferContext;

	changeSelectedIdMov = e => {
		this.setState({ selectedIdMov: e.value });
	};

	handleSelectFinancialPendingDebt = (itemId, replaceValues) => {
		const selectedDebts = this.state.selectedFinancialPendingDebts;
        const values = replaceValues ? [] : [...selectedDebts];
        const isChecking = !selectedDebts.includes(itemId);

        if (isChecking) values.push(itemId);
        else values.splice(values.indexOf(itemId), 1);

		this.setState({ selectedFinancialPendingDebts: values });
    }

	reportProblem = () => {
		const { selectedIdMov, txtAreaReportProblem, radioReportProblem, submitting } = this.state;

		const payload = {
			idMov: selectedIdMov,
			trouble: radioReportProblem,
			comments: txtAreaReportProblem
		};

		this.setState({ submitting: !submitting });

		postReportProblemResale(payload)
			.then(response => {
				this.setState({
					showModalResaleReportProblem: false,
					showModalFinancialPendingReportProblem: false,
					selectedIdMov: null,
					trouble: null,
					comment: null
				});
				this.setState({ submitting: !submitting });
			})
			.catch(error => {
				this.setState({ submitting: !submitting });
				console.error(error);
			});
	};

	displayDebitDetailsGrid = (resaleCharge, type) => {
		const { extracts } = resaleCharge;
		const { opened, index } = this.state;

		return extracts.map((item, idx) => (
			<div
				className={`row my-offers__debtDetailsGrid d-flex ${type === "collapse" ? "no-margin no-padding" : ""
					}`}
				key={idx}
			>
				<div className="col-xs-2 col-lg-1 pt-16 debtDetailGrid__radio">
					<Radio
						onChange={this.changeSelectedIdMov}
						horizontally={false}
						options={[{ value: item.idmov || "" }]}
						name="report-problem"
					/>
				</div>
				<div
					className={`${"col-lg-15"
						} col-xs-12 col-lg-15 d-flex debtDetails`}
				>
					<div className="col-xs-8 col-lg-2 pt-8">
						<span>Data</span>
						<span title={formatDateToLocalDate(item.created)}>
							{formatDateToLocalDate(item.created)}
						</span>
					</div>
					<div className="col-xs-8 col-lg-2 pt-8">
						<span>CIA</span>
						<span>{item.isInternational && item.cia !== "Tap" ? "Inter" : item.cia}</span>
					</div>
					<div
						className={`col-xs-16 col-lg-6 pt-16 pt-md-8 debtDetails__description ${index === idx ? "" : "collapsed"
							}`}
					>
						<span>Descrição</span>
						<span>{item.description}</span>
					</div>
					<div className={`col-xs-8 col-lg-2 pt-16 pt-md-8 ${index === idx ? "" : "collapsed"}`}>
						<span>Milhas</span>
						<span>{intFormat(item.miles || 0)}</span>
					</div>
					<div className={`col-xs-8 col-lg-3 pt-16 pt-md-8 ${index === idx ? "" : "collapsed"}`}>
						<span>Valor</span>
						{item.value < 0 ? (
							<span>{formatCurrency(item.value * -1, "R$ -")}</span>
						) : (
							<span>{formatCurrency(item.value || 0)}</span>
						)}
					</div>
					<div
						className={`col-xs-16 col-lg-1 pt-16 pt-md-8 debtDetails__salesLink ${index === idx ? "" : "collapsed"
							}`}
					>
						{item.idtransactions && <SalesLink toRouter={`${ROUTE_SALE}?searchTerm=${item.idtransactions}`} />}
					</div>
					
				</div>

				<div
					className="col-xs-2 col-lg-1 pt-16 visible-xs visible-sm"
					onClick={() => {
						this.setState({ opened: !opened });
						index === idx ? this.setState({ index: undefined }) : this.setState({ index: idx });
					}}
				>
					{index === idx ? <i className="icon-arrow-up" /> : <i className="icon-arrow-down" />}
				</div>
			</div>
		));
	};

	displayFinancialPendingDetailsGrid = (financialPendingCharge, type) => {
		const { content } = financialPendingCharge;
		const { openedFinancialPending, indexFinancialPending } = this.state;
		const selectedDebts = this.state.selectedFinancialPendingDebts;
		const activeDebts = content.filter(debt => debt.statusId === 1);

		return activeDebts.map((item, idx) => {
			const { 
				id, 
				idtransactions, 
				createdAt, 
				isInternational, 
				airlineName, 
				description, 
				amount 
			} = item;
			const isSelected = selectedDebts.includes(id);
			const isOpened = indexFinancialPending === idx || isSelected;
			const optionData = {
				value: id,
				checked: isSelected
			}

			return (
				<div
					className={`row my-offers__debtDetailsGrid d-flex ${type === "collapse" ? "no-margin no-padding" : ""
						}`}
					key={`debt_${id}`}
				>
					<div className="col-xs-2 col-lg-1 pt-16 debtDetailGrid__radio">
						<Checkbox 
							key={id.toString()}
							onChange={() => this.handleSelectFinancialPendingDebt(id, false)} 
							options={[optionData]}
						/>
					</div>
					<div
						className={`${idtransactions ? "col-lg-15" : "col-lg-16"
							} col-xs-12 col-lg-15 d-flex debtDetails`}
					>
						<div className="col-xs-8 col-lg-2 pt-8">
							<span>Data</span>
							<span title={formatDateToLocalDate(createdAt)}>
								{formatDateToLocalDate(createdAt)}
							</span>
						</div>
						<div className="col-xs-8 col-lg-2 pt-8 capitalize">
							<span>CIA</span>
							<span>{isInternational && airlineName !== "Tap" ? "Inter" : airlineName}</span>
						</div>
						<div
							className={`col-xs-16 col-lg-8 pt-16 pt-md-8 debtDetails__description ${isOpened ? "" : "collapsed"
								}`}
						>
							<span>Descrição</span>
							<span>{description}</span>
						</div>
						<div className={`col-xs-8 col-lg-3 pt-16 pt-md-8 ${isOpened ? "" : "collapsed"}`}>
							<span>Valor</span>
							{amount < 0 ? (
								<span>{formatCurrency(amount * -1, "R$ -")}</span>
							) : (
								<span>{formatCurrency(amount || 0)}</span>
							)}
						</div>
					</div>

					<div
						className="col-xs-2 col-lg-1 pt-16 visible-xs visible-sm"
						onClick={() => {
							this.setState({ openedFinancialPending: !openedFinancialPending });
							indexFinancialPending === idx ? this.setState({ indexFinancialPending: undefined }) : this.setState({ indexFinancialPending: idx });
						}}
					>
						{isOpened ? <i className="icon-arrow-up" /> : <i className="icon-arrow-down" />}
					</div>
				</div>
			)
		});
	};

	getExtractResaleDetails(payload) {
		getExtractResale(payload.username)
			.then(response => {
				this.setState({
					resaleCharge: response.data.resealeCharge,
					resale: { ...this.state.resale, hasDebt: true }
				});
			})
			.catch(error => console.error(error));
	}

	getFinancialPendingDetails(payload) {
		const { email } = payload;

		getCustomerFinancialPending(email)
			.then(response => {
				const hasActivePending = !!response.data?.content?.length;
				
				if (hasActivePending) {
					this.setState({
						financialPendingCharge: response.data,
						financialPending: { ...this.state.financialPending, hasFinancialPending: true }
					});
				}
			})
			.catch(error => console.error(error));
	}

	solveDebtClick(value, paymentMade = false) {
		const token = getUserToken();
		const payload = jwt_decode(token);

		value
			? this.setState({
				resale: { ...this.state.resale, solveDebtNow: value, solveDebtLater: !value }
			})
			: this.setState({
				resale: { ...this.state.resale, solveDebtNow: value, solveDebtLater: !value }
			});

		if (!paymentMade) {
			this.setState({ selectedIdMov: null });
			postLogDecisionResale({ idUser: payload.id, choice: value ? "A" : "D" });
		}
	}

	solveFinancialPendingClick(selectedDebts) {
		const data = {
			billingIds: [...selectedDebts]
		}

		this.setState({
			isGeneratingPaymentLink: true
		});

		postCreatePaymentUrl(data)
			.then(response => {
				const url = response?.data?.paymentUrl;
				this.setState({
					isGeneratingPaymentLink: false
				});
	
				if (url) window.location.href = url;
			})
			.catch(error => {
				this.setState({
					isGeneratingPaymentLink: false,
					showFinancialPendingPaymentError: true,
					financialPendingModalData: { ...financialPendingModalData.error }
				})
				console.error(error)
			});
	}

	solveFinancialPendingLaterClick(value) {
		this.setState({
			financialPending: { ...this.state.financialPending, solveFinancialPendingLater: true },
			selectedFinancialPendingDebts: []
		});
	}

	getInstallments(payload) {
		getInstallmentsResale(payload.username)
			.then(response => {
				const { installmentsValue } = response.data && response.data.installments;
				this.setState({ installments: installmentsValue.length });
			})
			.catch(error => {
				console.error(error);
			});
	}

	onCloseReportProblem = () => {
		this.setState({
			radioReportProblem: null,
			txtAreaReportProblem: "",
			showModalResaleReportProblem: false,
			showModalFinancialPendingReportProblem: false
		});
	};

	showPaymentStatusModal(paymentStatus) {
		if (!paymentStatus) return;

		if (paymentStatus) 
			this.setState({ showFinancialPendingPaymentStatusModal: true });
	}

	componentDidMount() {
		const { data, loading } = this.props;
		const searchParams = new URLSearchParams(window.location.search);
		const paymentStatus = searchParams.get('order_id');
		let self = this;

		if (!loading && !data) {
			this.props.refreshOffers();
		} else {
			this.handleOffers(this.props);
		}
		getCancelationReasons()
			.then(response => {
				let options = response.data;
				self.setState({
					options
				});
			})
			.catch(error =>
				self.setState({
					showDelete: false
				})
			);

		this.showPaymentStatusModal(paymentStatus);

		this.setState({ failedSend: false });
		const token = getUserToken();
		const payload = jwt_decode(token);
		this.getExtractResaleDetails(payload);
		this.getFinancialPendingDetails(payload);
		this.getInstallments(payload);
	}

	componentWillReceiveProps(nextProps) {
		const { error, offerInQuickSale, failedSend } = nextProps;

		if (offerInQuickSale && offerInQuickSale.message) {
			this.handleErrors(offerInQuickSale, failedSend);
		} else {
			this.setState({ failedSend: false });
		}

		if (error) {
			this.props.isNewUser(true);
		} else {
			this.handleOffers(nextProps);
		}
	}

	handleErrors(offerInQuickSale, failedSend) {
		if (offerInQuickSale) {
			switch (offerInQuickSale.message) {
				case "Invalid username for airline program!":
					this.setState({
						errorModal: errorsOptions.find(x => x.key === offerInQuickSale.message).value
					});
					break;
				default:
					this.setState({ failedSend: failedSend });
			}
		}
	}

	handlePriceChange() {
		const { offerInQuickSale } = this.props;
		this.setState({ errorModal: false });
		this.edit(offerInQuickSale.offer);
	}

	confirmEdit() {
		this.edit(this.state.offerToEdit, true);
		this.setState({
			offerToEdit: undefined,
			showModalNaoElegivel: false,
			showModalNaoElegivelPagamentoAntecipado: false,
			showModalPerderBonus: false
		});
	}

	edit(offer, ignoreModal) {
		const isRedirectOfferSellLP = window.offerSellAB;

		if (isRedirectOfferSellLP) {
			this.registerCookieToOfferByType("edit", offer?.fidelity?.airlineAcronym);
			window.location.href = window.location.origin + ROUTE_SALE_MILES;
			return;
		}

		const { history } = this.props;

		/*
		 * Verificar venda rapida
		 * 1 - Convencional
		 * 2 - Venda Rápida
		 * 4- Pagamento Antecipado
		 */
		if ((offer.type == 2 || !!offer.hasBonus) && !ignoreModal) {
			this.setState({
				offerToEdit: offer,
				showModalNaoElegivel: offer.type == 2,
				showModalPerderBonus: !!offer.hasBonus
			});
			return;
		}

		if ((offer.type == 4 || !!offer.hasBonus) && !ignoreModal) {
			this.setState({
				offerToEdit: offer,
				showModalNaoElegivelPagamentoAntecipado: offer.type == 4,
				showModalPerderBonus: !!offer.hasBonus
			});
			return;
		}

		logEvent("edit_offer_button");
		window.scrollTo(0, 0);
		localStorage.setItem("SimulatorMilesAviso", "1");
		localStorage.setItem("EditOfferOrNewOffer", "0");
		window.newOfferContext.selectOfferToEdit(offer, history);
	}

	handleOffers(props) {
		const { data } = props;
		const { sortOption, asc } = this.state;

		if (data && data.offers && data.offers.length) {
			this.sortOffers(sortOption, asc, data.offers);

			if (
				data.offers.some(offer => OfferStatus[offer.status] === "Ativa") &&
				localStorage.getItem("OfferFilterActive")
			) {
				this.setState({
					filterOption: "Ativa",
					filterOptionSelected: {
						label: "Ativa",
						value: "Ativa"
					}
				});
			}
			this.setState({
				filterOptions: [
					{
						label: "Todos",
						value: ""
					},
					data.offers.some(offer => OfferStatus[offer.status] === "Ativa")
						? {
							label: "Ativa",
							value: "Ativa"
						}
						: "",
					data.offers.some(offer => OfferStatus[offer.status] === "Em venda")
						? {
							label: "Em venda",
							value: "Em venda"
						}
						: "",
					data.offers.some(offer => OfferStatus[offer.status] === "Em análise")
						? {
							label: "Em análise",
							value: "Em análise"
						}
						: "",
					data.offers.some(offer => OfferStatus[offer.status] === "Inativa")
						? {
							label: "Inativa",
							value: "Inativa"
						}
						: ""
				]
			});
		}
	}

	handleStatusChange(status) {
		const { filterOption } = this.state;
		status = filterOption === status ? "" : status;

		// Trazer filtrado ofertas "Ativas"
		localStorage.setItem("OfferFilterActive", "1");
		if (status == "") {
			let labelStatus = "Todos";
			this.setState({
				filterOption: status,
				filterOptionSelected: { label: labelStatus, value: status }
			});
		} else {
			this.setState({
				filterOption: status,
				filterOptionSelected: { label: status, value: status }
			});
		}
	}

	componentWillUnmount() {
		this._unmounted = true;
	}

	cancelModalDelete() {
		this.setState({ showDelete: false });
	}

	confirmModalDelete(reason, comment) {
		const token = getUserToken();
		const { offer } = this.state;
		let self = this;
		self.setState({ loadingDelete: true });

		deleteOffer(token, offer.id, reason, comment)
			.then(res => {
				if (self._unmounted) return;
				logEvent("delete_offer_button", {
					remove_option: reason.name,
					remove_comment: comment
				});
				self.setState({ showDelete: false, loadingDelete: false });
				self.props.refreshOffers();
			})
			.catch(res => {
				if (self._unmounted) return;
				self.setState({ showDelete: false, loadingDelete: false });
			});
	}

	setComponentQuickSaleActive(status) {
		this.setState({ hasComponentQuickSaleActive: status });
	}

	showModalDelete(offer) {
		this.setState({ offer, showDelete: true });
	}

	verifyLatamPhoneType(offer) {
		if (offer.fidelity.airlineAcronym === "Latam") {
			return offer.phoneRequiredMode;
		} else {
			return 1;
		}
	}

	closeFinancialPendingPaymentModal() {
		const searchParams = new URLSearchParams(window.location.search);
		
		searchParams.delete('order_id');
		const updatedParamsStr = searchParams.size ? `?${searchParams.toString()}` : '';

		window.history.replaceState({}, '', window.location.pathname + updatedParamsStr);

		this.setState({ 
			showFinancialPendingPaymentStatusModal: false,
			showFinancialPendingPaymentError: false
		});
	}

	sortOffers(sortOption, asc, allOffers) {
		allOffers = allOffers || this.state.allOffers;
		asc = asc != undefined ? asc : this.state.asc;

		if (allOffers) {
			let fields = R.path(sortOption.value.split("."));
			let direction =
				sortOption.value == "lastUpdate" // inverte
					? asc
						? R.descend(fields)
						: R.ascend(fields)
					: asc
						? R.ascend(fields)
						: R.descend(fields);
			let sorted = R.sortWith([direction]);

			this.setState({
				allOffers: sorted(allOffers),
				asc,
				sortOption
			});
		}
	}

	registerCookieToOfferByType(type, acronym = null) {
		const cookie = {
			type,
			acronym
		}

		setCookie("redirect-offer-sell", cookie, CookieTypes.REQUIRED);
	}

	render() {
		const {
			locale,
			allOffers,
			loadingDelete,
			sortOption,
			asc,
			filterOption,
			filterOptionSelected,
			filterOptions,
			failedSend,
			options,
			hasComponentQuickSaleActive,
			resale,
			resaleCharge,
			financialPending,
			financialPendingCharge,
			selectedFinancialPendingDebts,
			isGeneratingPaymentLink,
			installments,
			selectedIdMov,
			radioReportProblem,
			txtAreaReportProblem,
			showModalResaleReportProblem,
			showModalFinancialPendingReportProblem
		} = this.state;

		const { loading: loadingOffers, data } = this.props;
		const { hasDebt, solveDebtLater, solveDebtNow } = resale;
		const { hasFinancialPending, solveFinancialPendingLater } = financialPending;
		const { phoneMultiplus } = this.context;

		const buttonReportProblemResale = (
			<ButtonAtomic
				color={`${!selectedIdMov ? "#c8ccd4" : "#2d8abd"}`}
				disabled={!selectedIdMov}
				onClick={() => {
					this.setState({ showModalResaleReportProblem: true });
				}}
				size="small"
				type="button"
				className="my-offers--reportProblemBtn"
			>
				{resaleCommonContent.buttonTextReportProblem}
			</ButtonAtomic>
		);

		const buttonReportProblemFinancialPending = (
			<ButtonAtomic
				color={`${!selectedFinancialPendingDebts.length ? "#c8ccd4" : "#2d8abd"}`}
				disabled={!selectedFinancialPendingDebts.length}
				onClick={() => {
					this.setState({ showModalFinancialPendingReportProblem: true });
				}}
				size="small"
				type="button"
				className="my-offers--reportProblemBtn"
			>
				{financialPendingCommonContent.buttonTextReportProblem}
			</ButtonAtomic>
		);

		const formReportResaleProblem = (
			<ModalReportProblem 
				options={reportOptions.resale}
				opened={showModalResaleReportProblem}
				onClose={() => this.onCloseReportProblem()}
				onChangeOption={e => {
					this.setState({ radioReportProblem: +e.value });
				}}
				onChangeMessage={e => {
					this.setState({ txtAreaReportProblem: e.target.value });
				}}
				onSubmit={() => this.reportProblem()}
				disabled={(!radioReportProblem && !txtAreaReportProblem) || this.state.submitting}
			/>);

		const formReportFinancialPendingProblem = (
			<ModalReportProblem 
				options={reportOptions.financialPending}
				opened={showModalFinancialPendingReportProblem}
				onClose={() => this.onCloseReportProblem()}
				onChangeOption={e => {
					this.setState({ radioReportProblem: +e.value });
				}}
				onChangeMessage={e => {
					this.setState({ txtAreaReportProblem: e.target.value });
				}}
				onSubmit={() => this.reportProblem()}
				disabled={(!radioReportProblem && !txtAreaReportProblem) || this.state.submitting}
			/>);
			
		const renderResaleDebtsPanel = () => {
			if (!this.state.resale.hasDebt) return;

			return (
				<div className="col-xs-16 mb-24">
					{solveDebtNow ? (
						<ResaleForm
							total={resaleCharge.debit.totalDebit}
							percent={resaleCharge.debit.discount}
							totalDiscounted={resaleCharge.debit.totalDiscounted}
							closeResale={this.solveDebtClick}
						/>
					) : (
						<>
							<CollapseCard
								cardTitle={resaleCommonContent.title}
								cardText={resaleCommonContent.text}
								collapseText="Valor do débito"
								collapseSmallText={
									installments ? `Pague em até ${installments}x no cartão` : undefined
								}
								collapseTextHighlight={formatCurrency(resaleCharge.debit.totalDebit) || 0}
								buttonTextOk={resaleCommonContent.buttonText}
								buttonTextCancel="Ver minhas ofertas"
								onClickOk={() => this.solveDebtClick(true)}
								onClickCancel={() => this.solveDebtClick(false)}
								dataAction="summary-payment-expand-collapse-card-resale"
							>
								{/* <div className="row">
									<div className="col-xs-16 col-sm-3">{buttonReportProblemResale}</div>
								</div> */}
								<div className="my-offers__debtDetailsBox">
									{this.displayDebitDetailsGrid(resaleCharge)}
								</div>
								{showModalResaleReportProblem && formReportResaleProblem}
							</CollapseCard>
						</>
					)}
				</div>
			);
		}

		const renderFinancialPendingPanel = () => {
			if (!this.state.financialPending.hasFinancialPending) return;

			const hasSelection = !!selectedFinancialPendingDebts.length;

			return (
				<div className="col-xs-16 mb-24">
					<>
						<CollapseCard
							cardTitle={financialPendingCommonContent.title}
							cardText={financialPendingCommonContent.text}
							collapseText="Valor do débito"
							collapseSmallText={
								installments ? `Pague em até ${installments}x no cartão` : undefined
							}
							collapseTextHighlight={formatCurrency(financialPendingCharge.totalDebt) || 0}
							buttonTextOk={financialPendingCommonContent.buttonText}
							disabledButton={!hasSelection || isGeneratingPaymentLink}
							buttonTextCancel="Ver minhas ofertas"
							onClickOk={() => this.solveFinancialPendingClick(selectedFinancialPendingDebts)}
							onClickCancel={() => this.solveFinancialPendingLaterClick()}
							dataAction="summary-payment-expand-collapse-card-resale"
						>
							{/* <div className="row">
								<div className="col-xs-16 col-sm-3">{buttonReportProblemFinancialPending}</div>
							</div> */}
							<div className="my-offers__debtDetailsBox">
								{this.displayFinancialPendingDetailsGrid(financialPendingCharge)}
							</div>
							{showModalFinancialPendingReportProblem && formReportFinancialPendingProblem}
						</CollapseCard>
					</>
				</div>
			);
		}

		const renderResaleDebtsSolveLaterPanel = () => {
			if (!this.state.resale.hasDebt) return;

			return (
				<div className="row">
					<div className="col-xs-16 mb-24">
						<Collapse
							title={resaleCommonContent.title}
							text={resaleCommonContent.text}
							buttonText={resaleCommonContent.buttonText}
							dataAction="summary-payment-expand-collapse-resale"
							onClick={() => this.solveDebtClick(true)}
						>
							{/* <div className="row">
								<div className="col-xs-16 col-sm-3">{buttonReportProblemResale}</div>
							</div> */}
							<div className="my-offers__debtDetailsBox no-margin no-padding">
								{this.displayDebitDetailsGrid(resaleCharge, "collapse")}
							</div>
							{showModalResaleReportProblem && formReportResaleProblem}
						</Collapse>
					</div>
				</div>
			);
		}

		const renderFinancialPendingSolveLaterPanel = () => {
			if (!this.state.financialPending.hasFinancialPending) return;

			const hasSelection = !!selectedFinancialPendingDebts.length;

			return (
				<div className="row">
					<div className="col-xs-16 mb-24">
						<Collapse
							title={financialPendingCommonContent.title}
							text={financialPendingCommonContent.text}
							buttonText={financialPendingCommonContent.buttonText}
							dataAction="summary-payment-expand-collapse-resale"
							disabledButton={!hasSelection || isGeneratingPaymentLink}
							onClick={() => this.solveFinancialPendingClick(selectedFinancialPendingDebts)}
						>
							{/* <div className="row">
								<div className="col-xs-16 col-sm-3">{buttonReportProblemFinancialPending}</div>
							</div> */}
							<div className="my-offers__debtDetailsBox no-margin no-padding">
								{this.displayFinancialPendingDetailsGrid(financialPendingCharge, "collapse")}
							</div>
							{showModalFinancialPendingReportProblem && formReportFinancialPendingProblem}
						</Collapse>
					</div>
				</div>
			);
		}

		return (
			<>
				{(hasDebt && !solveDebtLater) || (hasFinancialPending && !solveFinancialPendingLater) ? (
					<div className="my-offers">
						<div className="col-xs-16">
							{isGeneratingPaymentLink 
								? (
									<Modal
										show
										fixed
										title={<p className="modal__title modal text-center">Preparando pagamento...</p>}
										description={<div className="modal__description"><Loading label="Estamos gerando os dados para o pagamento. Isso pode levar alguns segundos, por favor aguarde..." /></div>}
										dontUseDefaultOption
										width={360}
										height={220}
									/>
								) : (
									<>
										{solveDebtLater ? renderResaleDebtsSolveLaterPanel() : renderResaleDebtsPanel()}
										{solveFinancialPendingLater ? renderFinancialPendingSolveLaterPanel() : renderFinancialPendingPanel()}
									</>
								)
							}
						</div>
					</div>
				) : (
					<div className="my-offers">
						<div className="col-xs-16">
							{solveDebtLater || solveFinancialPendingLater ? (
								<>
									{renderResaleDebtsSolveLaterPanel()}
									{renderFinancialPendingSolveLaterPanel()}
								</>
							) : (
								<SummaryPayment />
							)}
						</div>
						<div className="col-xs-16">
							<div className="my-offers--total">
								<div className="row">
									<div className="col-xs-16 col-md-13 col-lg-13 my-offers--total-text">
										Você possui <strong>{intFormat((data && data.totalMiles) || 0)}</strong> milhas
										<br />
										ativas no valor de{" "}
										<strong>{formatCurrency((data && data.priceTotal) || 0)}</strong>.
										<div className="my-offers--total-text-alert">
										</div>
									</div>
									<div
										className={`col-xs-16 col-md-3 col-lg-3 ${isMobile() ? "text-center" : "text-right"}`}
									>
										<NavLink
											className="btn btn-primary"
											data-action="my-offers-new-offer"
											to={ROUTE_SALE_MILES}
											onClick={() => {
												logEvent("new_offer_button");
												window.location.href = window.location.origin + ROUTE_SALE_MILES;
											}}
										>
											Nova oferta
										</NavLink>
									</div>
								</div>
							</div>

							{!loadingOffers && (<div
								className="my-offers--filter-container hidden-xs hidden-sm"
							>
								<div className={`row hidden-xs hidden-sm ${failedSend ? "my-offers--callout--margin" : ""
									}`}>
									<div className="col-xs-16 col-md-12 my-offers--filter">
										{allOffers.some(offer => OfferStatus[offer.status] === "Ativa") && (
											<Button
												onClick={e => this.handleStatusChange("Ativa")}
												className={`tab-active ${filterOption === "Ativa" ? "active-tab-active" : ""
													}`}
												data-action="my-offers-filter-active"
											>
												Ativas
											</Button>
										)}
										{allOffers.some(offer => OfferStatus[offer.status] === "Em venda") && (
											<Button
												onClick={e => this.handleStatusChange("Em venda")}
												className={`tab-on-sale ${filterOption === "Em venda" ? "active-tab-on-sale" : ""
													}`}
												data-action="my-offers-filter-on-sale"
											>
												Em venda
											</Button>
										)}
										{allOffers.some(offer => OfferStatus[offer.status] === "Em análise") && (
											<Button
												onClick={e => this.handleStatusChange("Em análise")}
												className={`tab-analyzing ${filterOption === "Em análise" ? "active-tab-analyzing" : ""
													}`}
												data-action="my-offers-filter-analyzing"
											>
												Em Análise
											</Button>
										)}
										{allOffers.some(offer => OfferStatus[offer.status] === "Inativa") && (
											<Button
												onClick={e => this.handleStatusChange("Inativa")}
												className={`tab-inactive ${filterOption === "Inativa" ? "active-tab-inactive" : ""
													}`}
												data-action="my-offers-filter-inactive"
											>
												Inativas
											</Button>
										)}
									</div>
									{allOffers.filter(offer =>
										filterOption !== "" ? OfferStatus[offer.status] == filterOption : offer.status > 0
									).length > 0 && (
											<div className="col-xs-16 col-md-4 my-offers--order">
												<Select
													id="sort-select"
													selected={sortOption}
													onChange={sortOption => this.sortOffers(sortOption)}
													options={sortOptions}
													name="sort"
													data-action="my-offers-sort-select"
												/>
												<i
													className={`sort-offer ${asc ? "asc" : "desc"}`}
													onClick={() => this.sortOffers(this.state.sortOption, !asc)}
													data-action="my-offers-order"
												/>
											</div>
										)}
								</div>
							</div>)}
							<div
								className={`col-xs-16 hidden-md hidden-lg my-offers--filter-select ${failedSend ? "my-offers--callout--margin" : ""
									}`}
							>
								<div className="row">
									<div className="v-center-columns">
										<label htmlFor="filter-select">Filtrar por: </label>
									</div>
									<div className="v-center-columns">
										<Select
											id="filter-select"
											selected={filterOptionSelected}
											onChange={filterOptionSelected =>
												this.handleStatusChange(filterOptionSelected.value)
											}
											options={filterOptions}
											name="filter-select"
											data-action="my-offers-filter-option-select"
										/>
									</div>
								</div>
							</div>
						</div>

						{loadingOffers && <Loading label="Buscando suas ofertas :)" />}

						{!loadingOffers &&
							allOffers &&
							allOffers
								.filter(offer =>
									filterOption !== "" ? OfferStatus[offer.status] == filterOption : offer.status > 0
								)
								.map((offer, index, array) => (
									<ItemListOffer
										key={offer.id}
										offer={offer}
										onDelete={this.showModalDelete}
										lastItem={array.length - 1 === index}
										hasComponentQuickSaleActive={hasComponentQuickSaleActive}
										phoneMMSuggestion={phoneMultiplus}
										setComponentQuickSaleActive={this.setComponentQuickSaleActive}
										edit={this.edit}
										typePhoneLatam={this.verifyLatamPhoneType(offer)}
									/>
								))}

						{!!this.state.showDelete && (
							<DeleteOfferModal
								close={this.cancelModalDelete}
								confirm={this.confirmModalDelete}
								loading={loadingDelete}
								options={options}
							/>
						)}
						{!!this.state.showModalNaoElegivel && (
							<EditarNaoElegivel
								show={this.state.showModalNaoElegivel}
								onCancel={() => this.setState({ showModalNaoElegivel: false })}
								onConfirm={this.confirmEdit}
							/>
						)}
						{!!this.state.showModalNaoElegivelPagamentoAntecipado && (
							<EditarNaoElegivelPagamentoAntecipado
								show={this.state.showModalNaoElegivelPagamentoAntecipado}
								onCancel={() => this.setState({ showModalNaoElegivelPagamentoAntecipado: false })}
								onConfirm={this.confirmEdit}
							/>
						)}
						{!!this.state.showModalPerderBonus && (
							<EditarPerderBonus
								show={this.state.showModalPerderBonus}
								onCancel={() => this.setState({ showModalPerderBonus: false })}
								onConfirm={this.confirmEdit}
							/>
						)}
					</div>
				)}

				<Modal
					show={this.state.showFinancialPendingPaymentStatusModal}
					fixed={true}
					title={<p className="modal__title modal">{financialPendingModalData.paid.title}</p>}
					description={<div className="modal__description">{financialPendingModalData.paid.text}</div>}
					confirm={financialPendingModalData.paid.buttonText}
					onConfirm={() => this.closeFinancialPendingPaymentModal()}
					width={360}
					height={220}
				/>

				<Modal
					show={this.state.showFinancialPendingPaymentError}
					fixed={true}
					title={<p className="modal__title modal">{financialPendingModalData.error.title}</p>}
					description={<div className="modal__description">{financialPendingModalData.error.text}</div>}
					confirm={financialPendingModalData.error.buttonText}
					onConfirm={() => this.closeFinancialPendingPaymentModal()}
					width={360}
					height={220}
				/>
			</>
		);
	}
}

const mapStateToProps = state => ({
	data: state.offers.data,
	loading: state.offers.loading,
	error: state.offers.error,
	offerInQuickSale: state.offers.showSendModal,
	failedSend: !state.offers.successSend && !!state.offers.showSendModal
});

const mapDispatchToProps = dispatch => {
	return {
		isNewUser: newUser => dispatch(isNewUser(newUser)),
		refreshOffers: () => dispatch(refreshOffers()),
		editOffer: offer => dispatch(editOffer(offer))
	};
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(MyOffers), {
	mobileLimit: 468, // TODO Fix screen vars
	tabletLimit: 768, // TODO Fix screen vars
	shouldListenOnResize: true
});
